import { service } from '@ember/service';
import Component from '@glimmer/component';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

export default class GlobalDesksComponent extends Component {
  @service declare globalOverviewAccess: GlobalOverviewAccessService;
}
